import React, { Component } from 'react';
export default class ToggleButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      on: (props.on ? true : false)
    }
  }
  switchOption = () => {
    this.setState({ on: !this.state.on });
    if (this.state.on) {
      this.props.onOff();
    } else {
      this.props.onOn();
    }
  }
  render() {
    return (
      <div className={"toggleContainer"} onClick={this.switchOption}>
        <div className={"toggleLine " + (this.state.on ? "active" : "inActive")}>
          <div className={"wrapper"}>
            <div className={"toggleThumb " + (this.state.on ? "active" : "inActive")}></div>
            <div className={"animation " + (this.state.on ? "active" : "inActive")}></div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/workSpace/Others/ToggleButton.jsx